const MONTH_LABELS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export function getInspectionPeriodRows(frequency) {
  switch (frequency) {
    case 'SIX_MONTHLY':
      return [
        { key: 'H1', label: '1st half (Jan–Jun)' },
        { key: 'H2', label: '2nd half (Jul–Dec)' },
      ];
    case 'QUARTERLY':
      return [
        { key: 'Q1', label: 'Q1 (Jan–Mar)' },
        { key: 'Q2', label: 'Q2 (Apr–Jun)' },
        { key: 'Q3', label: 'Q3 (Jul–Sep)' },
        { key: 'Q4', label: 'Q4 (Oct–Dec)' },
      ];
    case 'MONTHLY':
      return MONTH_LABELS.map((label, i) => ({
        key: `M${String(i + 1).padStart(2, '0')}`,
        label,
      }));
    case 'DAILY':
      return Array.from({ length: 31 }, (_, i) => ({
        key: `D${String(i + 1).padStart(2, '0')}`,
        label: `${i + 1} Jan`,
      }));
    case 'ANNUAL':
    default:
      return [{ key: 'A1', label: 'Annual inspection' }];
  }
}

export function parseInspectionPeriodMethods(raw) {
  if (!raw) return {};
  if (typeof raw === 'object' && !Array.isArray(raw)) return raw;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}
